import TweetEmbed from "react-tweet-embed";

function tweetIdFromUrl(url) {
  const statusMatch = url.expanded_url.match(/status\/(\d+)/);
  return statusMatch ? statusMatch[1] : null;
}

function getTweetTextWithEntities(tweet) {
  if (!tweet.entities || !tweet.entities.urls) {
    return [tweet.text];
  }

  let idx = 0;
  let previousEntityTweetId;
  const tweetTextWithEntities = tweet.entities.urls.flatMap((url) => {
    // The same embedded tweet can show up twice in a row, which
    // would result in duplicate embedded tweets if we don't de-dupe.
    // We de-dupe by skipping over embedded tweets which we've
    // already seen.
    const entityTweetId = tweetIdFromUrl(url);
    if (entityTweetId) {
      if (previousEntityTweetId === entityTweetId) {
        return [];
      }

      previousEntityTweetId = entityTweetId;
    }

    const chunk = [
      tweet.text.slice(idx, url.start),
      url.display_url.match(/pic.twitter.com/)
        ? {
            ...url,
            media: tweet.media,
            type: tweet.media[0].type,
          }
        : url,
    ];
    idx = url.end;
    return chunk;
  });

  return tweetTextWithEntities;
}

function Entity(props) {
  const { entity } = props;

  if (entity.type === "photo") {
    return entity.media.map((mediaItem) => (
      <img
        key={mediaItem.url}
        src={mediaItem.url}
        alt={entity.display_url}
        width={mediaItem.width}
        height={mediaItem.height}
        className="p-4 m-auto"
      />
    ));
  }

  const tweetId = tweetIdFromUrl(entity);
  if (tweetId) {
    return <TweetEmbed id={tweetId} options={{ align: "center" }} />;
  }

  return (
    <a key={entity.url} href={entity.url} className="text-blue-600 break-all">
      {entity.expanded_url}
    </a>
  );
}

function Text(props) {
  const { text } = props;

  const lines = text.split("\n");

  return lines.map((line, idx) => (
    <p key={idx} className="py-1">
      {line}
    </p>
  ));
}

function Tweet(props) {
  const { tweet } = props;

  const tweetTextWithEntities = getTweetTextWithEntities(tweet);
  return (
    <div className="px-4">
      {tweetTextWithEntities.map((chunk) => {
        return typeof chunk === "string" ? (
          <Text key={chunk} text={chunk} />
        ) : (
          <Entity key={chunk.url} entity={chunk} />
        );
      })}
    </div>
  );
}

export default Tweet;
